import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Customer } from '../../models/customer';
import { VerticalSelectorService } from '../../services/vertical-selector.service';
import { getStorageObject } from '../../utils/storage-manager';
import { securityDomain } from '../main/main.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  private verticalSelectorService = inject(VerticalSelectorService);
  private router = inject(Router);

  protected readonly securityDomain = securityDomain;
  protected currentCustomer: Customer | null = getStorageObject('vertical');

  goToSelector(): void {
    this.verticalSelectorService.setVertical(null);
    this.router.navigateByUrl('vertical-selector');
  }

  /**
   * Redirect to path
   * @param url Url to redirect
   */
  redirect(url: string | null): void {
    url ? this.router.navigateByUrl(url) : this.router.navigateByUrl('');
  }
}
